//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ObjectFunc = require('@/tbs/util/ObjectFunc')

/**
 * The CityRegion class acts as the view object for the organization.
 */
const tbs_model_vo_CityRegion = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_CityRegion.prototype = {
    /* The view object name */
    name: 'cityRegion',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetAreaTreeList',
            basePath: 'data.list',
            rule: {
                areaList: '$list',
                areaIdList: '$list'
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    /**
     * @private
     * Format the organization position field according to the given fields.
     */
    formatAreaId: function(area, areaIdList) {
        console.log('formatAreaId', area, areaIdList)
        if (areaIdList.province_list[area]) {
            return areaIdList.province_list[area]
        }
        else if (areaIdList.city_list[area]) {
            return areaIdList.city_list[area]
        }
        else if (areaIdList.county_list[area]) {
            return areaIdList.county_list[area]
        }
    },
    renderAreaList: function(list) {
        const areaList = {
            province_list: {},
            city_list: {},
            county_list: {}
        }
        // console.log('list', list)
        const treeList = JSON.parse(list.replaceAll("'", '"')) || [];
        console.log('treeList', treeList)
        let provinceItem, cityItem, countyItem
        let key
        for (let i = 0; i < treeList.length; i++) {
            provinceItem = treeList[i]
            key = i + 11 + '0000'
            areaList.province_list[key] = provinceItem.name
            if (provinceItem.kids) {
                for (let j = 0; j < provinceItem.kids.length; j++) {
                    cityItem = provinceItem.kids[j]
                    key = i + 11 + ObjectFunc.pad(j+1, 2) + '00'
                    areaList.city_list[key] = cityItem.name
                    if (cityItem.kids) {
                        for (let k = 0; k < cityItem.kids.length; k++) {
                            countyItem = cityItem.kids[k]
                            key = i + 11 + ObjectFunc.pad(j+1, 2) + ObjectFunc.pad(k+1, 2)
                            areaList.county_list[key] = countyItem.name
                        }
                    }
                }
            }
        }
        return areaList
    },
    renderAreaIdList: function(list) {
        const areaIdList = {
            province_list: {},
            city_list: {},
            county_list: {}
        }
        // console.log('list', list)
        const treeList = JSON.parse(list.replaceAll("'", '"')) || [];
        console.log('treeList', treeList)
        let provinceItem, cityItem, countyItem
        let key
        for (let i = 0; i < treeList.length; i++) {
            provinceItem = treeList[i]
            key = i + 11 + '0000'
            areaIdList.province_list[key] = provinceItem.id
            if (provinceItem.kids) {
                for (let j = 0; j < provinceItem.kids.length; j++) {
                    cityItem = provinceItem.kids[j]
                    key = i + 11 + ObjectFunc.pad(j+1, 2) + '00'
                    areaIdList.city_list[key] = cityItem.id
                    if (cityItem.kids) {
                        for (let k = 0; k < cityItem.kids.length; k++) {
                            countyItem = cityItem.kids[k]
                            key = i + 11 + ObjectFunc.pad(j+1, 2) + ObjectFunc.pad(k+1, 2)
                            areaIdList.county_list[key] = countyItem.id
                        }
                    }
                }
            }
        }
        return areaIdList
    }
}

module.exports = tbs_model_vo_CityRegion